<!--P040、P041、P042-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy">货品类别维护</div>
    </div>
    <!--表格-->
    <div class="cs_margin_top_sm div_search_result cs_padding_top border_dash cs_align_center">
      <!--货品大类-->
      <div class="div_search cs_inline_block width_510" style="vertical-align: top;">
        <div class="ui_divider_title">
          <div class="title_info left_0 cs_align_left">货品大类</div>
        </div>
        <div class="div_table cs_margin_top_sm">
          <table class="cs_table cs_thead_fixed cs_td_divider_none" width="100%">
            <thead>
            <tr>
              <th width="40px">序号</th>
              <th width="100%">货品大类名称</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in serialList" :class="{ 'cs_tr_selected': item.isSelected}" @click="btnSelectTableTr(item)">
              <td width="40px">{{index+1}}</td>
              <td width="100%">{{item.typeName}}</td>
            </tr>
            <template v-if="PAGE_SIZE>serialList.length">
              <tr v-for="(item,index) in (PAGE_SIZE-serialList.length)">
                <td width="40px"></td>
                <td width="100%"></td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <div class="div_operation_table cs_margin_top_sm">
          <button @click="btnAdd" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_xs"
                  type="button">添加
          </button>
          <button @click="btnDelete" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr"
                  type="button">删除
          </button>
        </div>
      </div>
      <div class="div_search cs_inline_block position_border cs_margin_left_lg"></div>
      <!--货品小类-->
      <div class="div_search cs_inline_block width_510 cs_margin_left_lg" style="vertical-align: top;">
        <div class="ui_divider_title">
          <div class="title_info left_0 cs_align_left">货品小类</div>
        </div>
        <div class="div_table cs_margin_top_sm">
          <table class="cs_table cs_thead_fixed cs_td_divider_none" width="100%">
            <thead>
            <tr>
              <th width="40px">序号</th>
              <th width="100%">货品小类名称</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in typeList" :class="{ 'cs_tr_selected': item.isSelected}" @click="btnSelectTableTrType(item)">
              <td width="40px">{{index+1}}</td>
              <td width="100%">{{item.typeName}}</td>
            </tr>
            <template v-if="PAGE_SIZE>typeList.length">
              <tr v-for="(item,index) in (PAGE_SIZE-typeList.length)">
                <td width="40px"></td>
                <td width="100%"></td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <div v-show="isShowType" class="div_operation_table cs_margin_top_sm">
          <button @click="btnAddType" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_xs"
                  type="button">添加
          </button>
          <button @click="btnDeleteType" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr"
                  type="button">删除
          </button>
        </div>
      </div>
    </div>
    <div class="div_bottom"></div>

    <!--添加大类弹窗，默认隐藏-->
    <div v-if="isDialogAddShow" class="ui_div_dialog">
      <div class="ui_dialog_container" style="width:400px;height:266px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">添加货品大类</div>
        </div>
        <div class="cs_margin_top_lg div_search">
          <div class="cs_title_primary cs_text_default type_info_search ui_margin_left_18">货品大类</div>
          <input v-model="nameDialog" @input="nameDialogInput" class="cs_input cs_radius_lg edtxt_info_search width_246" placeholder="请输入">
        </div>
        <div class="cs_margin_top_sm cs_text_sm txt_hint_dialog">{{hintDialog}}</div>
        <!--确定取消按钮-->
        <div class="cs_margin_top_lg div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialog">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmAddDialog">确定</button>
        </div>
      </div>
    </div>
    <!--添加小类弹窗，默认隐藏-->
    <div v-if="isDialogAddTypeShow" class="ui_div_dialog">
      <div class="ui_dialog_container" style="width:400px;height:316px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">添加货品小类</div>
        </div>
        <div class="cs_margin_top_lg div_search">
          <div class="cs_title_primary cs_text_default type_info_search ui_margin_left_18">货品大类</div>
          <div class="cs_radius_lg txt_info_search width_246">{{serialNameDialogType}}</div>
        </div>
        <div class="ui_margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search ui_margin_left_18">货品小类</div>
          <input v-model="nameDialogType" @input="nameDialogTypeInput" class="cs_input cs_radius_lg edtxt_info_search width_246" placeholder="请输入">
        </div>
        <div class="cs_margin_top_sm cs_text_sm txt_hint_dialog">{{hintDialogType}}</div>
        <!--确定取消按钮-->
        <div class="cs_margin_top_lg div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialog">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmAddDialogType">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "material-type-manage",
    components: {},
    data: function () {
      return {
        serialList: [],
        selectedId: "",
        selectedName: "",
        typeList: [],
        selectedIdType: "",
        isShowType: false,
        isDialogAddShow: false,
        nameDialog: "",
        hintDialog: "",
        isDialogAddTypeShow: false,
        serialNameDialogType: "",
        nameDialogType: "",
        hintDialogType: "",
        PAGE_SIZE: 14,
      }
    },
    created: function () {
      this.showSerialList();
    },
    mounted: function () {
    },
    methods:{
      showSerialList(){
        this.serialList = [];
        this.selectedId = "";
        this.selectedName = "";
        this.typeList = [];
        this.selectedIdType = "";
        this.isShowType = false;
        this.$ajax.materialType.listMaterialType.bind(this)(0, (data) => {
          //显示列表
          let list = data.data;
          list.forEach((item) => {
            item.isSelected = false;
          });
          this.serialList = list;
        }, (data) => {
        }, true)
      },
      showTypeList(){
        this.$ajax.materialType.listMaterialType.bind(this)(this.selectedId, (data) => {
          //显示列表
          let list = data.data;
          list.forEach((item) => {
            item.isSelected = false;
          });
          this.typeList = list;
        }, (data) => {
        }, true)
      },
      btnSelectTableTr(item){
        let selectedStatus = item.isSelected;
        this.serialList.forEach((item1) => {
          item1.isSelected = false;
        });
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.selectedId = item.id;
          this.selectedName = item.typeName;
          this.isShowType = true;
          this.showTypeList();
        }else {
          this.selectedId = "";
          this.selectedName = "";
          this.typeList = [];
          this.selectedIdType = "";
          this.isShowType = false;
        }
      },
      btnDelete(){
        if(this.isEmpty(this.selectedId)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.$ajax.materialType.removeMaterialType.bind(this)(this.selectedId, (data) => {
          this.$toast("删除成功");
          this.showSerialList();
        }, (data) => {
        }, true)
      },
      btnAdd(){
        this.isDialogAddShow = true;
      },
      btnConfirmAddDialog(){
        if (this.isEmpty(this.nameDialog)) {
          this.hintDialog = "请输入货品大类";
          return
        }
        this.$ajax.materialType.addMaterialType.bind(this)(0, this.nameDialog, (data) => {
          this.$toast("添加成功");
          this.showSerialList();
          this.closeDialog();
        }, (data) => {
        }, true,this.showErrorMsg)
      },
      btnSelectTableTrType(item){
        let selectedStatus = item.isSelected;
        this.typeList.forEach((item1) => {
          item1.isSelected = false;
        });
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.selectedIdType = item.id;
        }else {
          this.selectedIdType = "";
        }
      },
      btnDeleteType(){
        if(this.isEmpty(this.selectedIdType)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.$ajax.materialType.removeMaterialType.bind(this)(this.selectedIdType, (data) => {
          this.$toast("删除成功");
          this.showTypeList();
        }, (data) => {
        }, true)
      },
      btnAddType(){
        this.serialNameDialogType = this.selectedName;
        this.isDialogAddTypeShow = true;
      },
      btnConfirmAddDialogType(){
        if (this.isEmpty(this.nameDialogType)) {
          this.hintDialogType = "请输入货品小类";
          return
        }
        this.$ajax.materialType.addMaterialType.bind(this)(this.selectedId, this.nameDialogType, (data) => {
          this.$toast("添加成功");
          this.showTypeList();
          this.closeDialog();
        }, (data) => {
        }, true,this.showErrorMsgType)
      },
      closeDialog() {
        this.isDialogAddShow = false;
        this.nameDialog = "";
        this.hintDialog = "";
        this.isDialogAddTypeShow = false;
        this.serialNameDialogType = "";
        this.nameDialogType = "";
        this.hintDialogType = "";
      },
      nameDialogInput(){
        this.hintDialog = "";
      },
      nameDialogTypeInput(){
        this.hintDialogType = "";
      },
      //错误提示
      showErrorMsg: function (msg) {
        this.hintDialog = msg;
      },
      showErrorMsgType: function (msg) {
        this.hintDialogType = msg;
      },

    }
  }
</script>

<style scoped>
  .border_dash{
    border: 2px dashed #D5D5D5;
  }
  .cs_table tbody {
    max-height: 574px;
  }
  .position_border{
    vertical-align: top;
    width: 2px;
    height: 640px;
    background-image: linear-gradient(to bottom, #D5D5D5 0%, #D5D5D5 50%, transparent 50%);
    background-size: 2px 10px;
    background-repeat: repeat-y;
  }
  .txt_hint_dialog{
    position: relative;
    width: 100%;
    height: 20px;
    line-height: 20px;
    color: #FFB54C;
    text-align: center;
  }
  .width_246{width: 246px;}
  .width_510{width: 500px;}
  .left_0{left: 0;}
</style>



// WEBPACK FOOTER //
// src/page/material-type/material-type-manage.vue